if (!customElements.get("share-ring-link")) {
  class ShareRingLink extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.updateCartFromUrl();
      this.generateShareLink();
      this.addEventListener("click", this.copyLink);
    }

    updateCartFromUrl() {
      const url = new URL(window.location.href);
      const params = this.parseQueryString(this.reverseShortenedURL(url.search));

      if (params.cart) {
        const cart = params.cart;
        url.search = ""; // Clear the URL query
        window.history.replaceState({}, document.title, url);
        this.updateCart(cart);
      }
    }

    async updateCart(cartData) {
      await fetch(`${routes.cart_url}/clear.js`);

      let url = cartData.items ? `${routes.cart_add_url}.js` : `${routes.cart_update_url}.js`;
      if (window.location.pathname.includes("pages")) {
        url = `${routes.cart_update_url}.js`;
        if (cartData.items) delete cartData.items;
      }

      /*     const ringProductHandle = cartData.attributes.ring.productHandle;
    let ringProduct = null;
    if (ringProductHandle) {
      ringProduct = await fetch(`/products/${ringProductHandle}.js`)
        .then((response) => response.json())
        .then((data) => data);
        //console.log("ringProduct", ringProduct); // Debugging
    }

    if (ringProduct && cartData.attributes.ring) {
      cartData.attributes.ring.product = ringProduct;
    } */

      const response = await fetch(url, {
        body: JSON.stringify(cartData),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest", // Shopify bug workaround
        },
      });

      const data = await response.json();
      //console.log("cart response", data); // Debugging
      window.location.reload(); // Refresh the window after cart update
    }

    generateShareLink() {
      const script = this.querySelector('script[type="application/json"]');
      const data = JSON.parse(script.textContent);
      //console.log("data", data); // Debugging
      if (data.cart.attributes["ring"]["product"]) delete data.cart.attributes["ring"]["product"];
      const urlParams = this.serialize(data);

      const urlFriendlyParams = this.shortenURL(urlParams);
      //console.log("urlFriendlyParams", urlFriendlyParams); // Debugging

      const url = new URL(window.location.href);
      url.search = urlFriendlyParams;
      this.setAttribute("data-href", url.href);
    }

    async copyLink() {
      const link = this.getAttribute("data-href");
      await navigator.clipboard.writeText(link);

      const copiedMsg = document.createElement("div");
      copiedMsg.textContent = "Link copied to clipboard";
      copiedMsg.classList.add("copied-msg");
      this.appendChild(copiedMsg);

      setTimeout(() => {
        copiedMsg.remove();
      }, 4000);
    }

    parseQueryString(query) {
      const params = new URLSearchParams(query);
      const result = {};

      for (const [key, value] of params.entries()) {
        const keys = key.split(/[\[\]]+/).filter(Boolean);
        keys.reduce((acc, k, i) => {
          if (i === keys.length - 1) {
            acc[k] = value;
          } else {
            acc[k] = acc[k] || (isNaN(keys[i + 1]) ? {} : []);
          }
          return acc[k];
        }, result);
      }

      return result;
    }

    serialize(obj, prefix = "") {
      const str = [];
      for (const [key, value] of Object.entries(obj)) {
        const fullKey = prefix ? `${prefix}[${key}]` : key;

        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            str.push(this.serialize(item, `${fullKey}[${index}]`));
          });
        } else if (typeof value === "object" && value !== null) {
          str.push(this.serialize(value, fullKey));
        } else {
          str.push(`${encodeURIComponent(fullKey)}=${encodeURIComponent(value)}`);
        }
      }
      return str.join("&");
    }

    shortenURL(str) {
      const shortended = str
        .replaceAll("%5B", "[")
        .replaceAll("%5D", "]")
        .replaceAll("cart[attributes][ring]", "HPcar")
        .replaceAll("[product][media]", "HPmdi")
        .replaceAll("[height]", "[h]")
        .replaceAll("[width]", "[w]")
        .replaceAll("[sources]", "[s]")
        .replaceAll("[attributes]", "HPts")
        .replaceAll("[aspect_ratio]", "[ar]")
        .replaceAll("[preview_image]", "[pr]")
        .replaceAll("[format]", "[ff]")
        .replaceAll("[position]", "[p]")
        .replaceAll("%2F%2Fregalhattongarden.co.uk%2Fcdn%2Fshop%2F", "rglUrl_1");
      // convert to base64
      return this.btoa_(shortended);
    }

    btoa_(str) {
      return window.btoa(str);
    }

    atob_(str) {
      return window.atob(str);
    }

    reverseShortenedURL(str) {
      //console.log("str", str); // Debugging
      let txt = this.atob_(str.replace("?", ""));
      txt = txt
        .replaceAll("HPcar", "cart[attributes][ring]")
        .replaceAll("HPmdi", "[product][media]")
        .replaceAll("[h]", "[height]")
        .replaceAll("[w]", "[width]")
        .replaceAll("[s]", "[sources]")
        .replaceAll("HPts", "[attributes]")
        .replaceAll("[ar]", "[aspect_ratio]")
        .replaceAll("[pr]", "[preview_image]")
        .replaceAll("[ff]", "[format]")
        .replaceAll("[p]", "[position]")
        .replaceAll("rglUrl_1", "%2F%2Fregalhattongarden.co.uk%2Fcdn%2Fshop%2F");

      return txt;
    }
  }

  customElements.define("share-ring-link", ShareRingLink);
}
